import Icon from '../components/Icon.vue'

Icon.register({
  grimace: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM144 400H136C118.3 400 104 385.7 104 368V360H144V400zM144 344H104V336C104 318.3 118.3 304 136 304H144V344zM136 208C136 190.3 150.3 176 168 176S200 190.3 200 208 185.7 240 168 240 136 225.7 136 208zM208 400H160V360H208V400zM208 344H160V304H208V344zM272 400H224V360H272V400zM272 344H224V304H272V344zM336 400H288V360H336V400zM336 344H288V304H336V344zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240zM392 368C392 385.7 377.7 400 360 400H352V360H392V368zM392 344H352V304H360C377.7 304 392 318.3 392 336V344z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grimace.js
// module id = GiDx
// module chunks = 144